import ListItemContentHybrid from "./ListItemContentHybrid";

/**
 * ListItemContent automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or a styled() extension).
 */
const ListItemContent = ListItemContentHybrid;

ListItemContent.displayName = "ListItemContent";

export default ListItemContent;
